/**
 * MODULE: _shared/frontend-shell/src/pages/LegacyOpportunitiesRedirect.tsx
 * PURPOSE: Redirect legacy /opportunities routes to golden CRM deals hub (/crm/deals)
 * PUBLIC_API: default LegacyOpportunitiesRedirect
 * AGENT_SAFETY: SAFE
 * RECENT: 2026-06-04 [2.2.1272] — List and detail legacy URLs map query facets via mapLegacyOpportunitiesSearchToCrmDeals; App.tsx routes use this component.
 */

import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { mapLegacyOpportunitiesSearchToCrmDeals } from './dashboard/legacyOpportunitiesRedirect';

export default function LegacyOpportunitiesRedirect() {
  const { opportunityId } = useParams<{ opportunityId?: string }>();
  const [searchParams] = useSearchParams();

  if (opportunityId?.trim()) {
    const id = decodeURIComponent(opportunityId.trim());
    const next = new URLSearchParams(searchParams);
    next.set('dealId', id);
    const qs = next.toString();
    return <Navigate to={qs ? `/crm/deals/${encodeURIComponent(id)}?${qs}` : `/crm/deals/${encodeURIComponent(id)}`} replace />;
  }

  const qs = mapLegacyOpportunitiesSearchToCrmDeals(searchParams).toString();
  return <Navigate to={qs ? `/crm/deals?${qs}` : '/crm/deals'} replace />;
}
